<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px; padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.schemeNo"
              placeholder="请输入方案编号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.schemeName"
              placeholder="请输入方案名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <date-select :search-date.sync="masterList.tableQuery.searchDate" />
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @export="batchExport(masterList)"
      />
    </div>
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 日期选择
import DateSelect from '@/components/DateSelect'

import { getUserId } from "@/utils/auth"
// API
import { loadSalaryActivityPerformanceInfoListDataApi, exportSalaryActivityPerformanceInfoListDataApi } from '@/api/v2/salaryActivityPerformanceInfo'

export default {
  name: 'SalaryActivityUserPerformanceInfoView',
  components: {
    CustomTable2,
    TableOperation2,
    DateSelect
  },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'salary_activity_user_performance_info_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['activity_user_performance_info_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          schemeNo: '',
          schemeName: '',
          searchDate: '',
          activitySub: 1,
          userId: ''
        }
      },
      id: null,
      eventType: '',
      dialogAddEditVisible: false,
      dialogAddEditTitle: '',

    }
  },
  created () {
    if(Number(getUserId()) !== 1){
      this.masterList.tableQuery.userId = getUserId()
    }
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'id', label: '单据编号', filterColumn: 'tsapi.id', width: 120 },
      { prop: 'sellId', label: '报告编号', filterColumn: 'tsapi.sell_id', width: 120 },
      { prop: 'performanceId', label: '发放编号', filterColumn: 'tsapi.performance_id', width: 120 },
      { prop: 'schemeNo', label: '方案编号', filterColumn: 'ts.project_no', width: 200 },
      { prop: 'schemeName', label: '方案名称', filterColumn: 'ts.name', width: 200 },
      { prop: 'isPerformanceValue', label: '是否计算绩效', filterColumn: 'tsapi.is_performance', filterValue: 'isPerformance', filterArray: [{ label: '未设置', value: 0 },{ label: '是', value: 1 }, { label: '否', value: 2 }], width: 140 },
      { prop: 'activityDate', label: '活动日期', filterColumn: 'tcbs.activity_date', width: 120, isBetween: true },
      { prop: 'feedbackTime', label: '最后审核时间', filterColumn: 'tcbs.feedback_time', width: 150, isBetween: true },
      { prop: 'provinceName', label: '省区', filterColumn: 'tcbs.province_name', width: 120 },
      { prop: 'cityName', label: '城市', filterColumn: 'tcbs.city_name', width: 120 },
      { prop: 'fieldTypeValue', label: '场次', filterColumn: 'tcbs.field_type', filterValue: 'fieldType', filterArray: [{ label: '一场半天', value: 1 }, { label: '一场一天', value: 2 }], width: 120 },
      { prop: 'userName', label: '人员名称', filterColumn: 'tr.name', width: 120 },
      { prop: 'isDisplayValue', label: '是否有展陈', filterColumn: 'tsapi.is_display', filterValue: 'isDisplay', filterArray: [{ label: '是', value: 1 }, { label: '否', value: 2 }], width: 160 },
      // { prop: 'displayAmount', label: '展陈数量', filterColumn: 'tsapi.display_amount', width: 120 },
      { prop: 'isMonthValue', label: '是否月度人员', filterColumn: 'tsapi.is_month', filterValue: 'isMonth', filterArray: [{ label: '是', value: 1 }, { label: '否', value: 2 }], width: 160 },
      { prop: 'performanceAmount', label: '绩效金额', filterColumn: 'tsapi.performance_amount', width: 160 },
      { prop: 'deductAmount', label: '绩效扣除金额', filterColumn: 'tsapi.deduct_amount', width: 160 },
      { prop: 'realPerformanceAmount', label: '实发绩效金额', filterColumn: 'tsapi.real_performance_amount', width: 160 },
      { prop: 'deductDescription', label: '绩效扣除说明', filterColumn: 'tsapi.deduct_description', width: 160 },
      { prop: 'statusValue', label: '发放状态', filterColumn: 'tsapi.status', filterValue: 'status', filterArray: [{ label: '未发放', value: 1 }, { label: '发放中', value: 2 }, { label: '已发放', value: 3 }, { label: '不发放', value: 4 }], width: 120 },
      { prop: 'remark', filterColumn: 'tsapi.remark', label: '备注', width: 220 },
      { prop: 'operatorName', filterColumn: 'tsapi.operator_name', label: '操作人', width: 120 },
      { prop: 'operationTime', filterColumn: 'tsapi.operation_time', label: '操作时间', width: 150, isBetween: true }
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this;
      loadSalaryActivityPerformanceInfoListDataApi(_this.masterList.tableQuery).then(response => {
        const { data } = response;
        this.handleData(data.list || [])
        this.masterList.tableDataTotal = data.total || 0
      }).catch()
    },
    // 导出数据API
    exportByPage () {
      let _this = this;
      exportSalaryActivityPerformanceInfoListDataApi(_this.exportObj).then(response => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
